module.exports = __webpack_public_path__ + "static/media/img112.24dc8c2d.jpg";